import { AddAccidentIncidentReport } from "app/screens/residents/show/AddAccidentIncidentReport";

export default function AddAccidentsIncidentsReportPage() {
  return <AddAccidentIncidentReport />;
}
